import { render, staticRenderFns } from "./ViewEditInteger.vue?vue&type=template&id=766096b2&scoped=true&"
import script from "./ViewEditInteger.vue?vue&type=script&lang=js&"
export * from "./ViewEditInteger.vue?vue&type=script&lang=js&"
import style0 from "./ViewEditInteger.vue?vue&type=style&index=0&id=766096b2&scoped=true&lang=css&"
import style1 from "./ViewEditInteger.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766096b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
